
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgInfoCircled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1155",
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    "data-name": "Path 90",
    d: "M10 2.25A7.751 7.751 0 002.25 10 7.75 7.75 0 0010 17.75 7.75 7.75 0 0017.75 10 7.751 7.751 0 0010 2.25zm0 14A6.246 6.246 0 013.75 10 6.248 6.248 0 0110 3.75 6.248 6.248 0 0116.25 10 6.246 6.246 0 0110 16.25zm0-10.562A1.312 1.312 0 008.688 7 1.312 1.312 0 0010 8.313 1.312 1.312 0 0011.313 7 1.312 1.312 0 0010 5.688zm1.75 7.937v-.75a.375.375 0 00-.375-.375H11V9.375A.375.375 0 0010.625 9h-2a.375.375 0 00-.375.375v.75a.375.375 0 00.375.375H9v2h-.375a.375.375 0 00-.375.375v.75a.375.375 0 00.375.375h2.75a.375.375 0 00.375-.375z"
  })));
}

export { SvgInfoCircled as default };
//# sourceMappingURL=info-circled.svg.js.map
